module.exports = __webpack_public_path__ + "img/ncr.9cf98381.png";